import { render } from "./Header.vue?vue&type=template&id=204c250c"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=204c250c&lang=scss"

import exportComponent from "C:\\Users\\Riccardo\\Desktop\\vue-app\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__